import React from 'react';
import { CodeSamples } from '..';
import { CodeType } from '../CodeType';
import { BuildCodeParams } from '../samples/CodeSample';
import CodeSampleTabs from './CodeSampleTabs';
import Paragraph from 'antd/lib/typography/Paragraph';

const MobileCodeSampleTabs: React.FC<Partial<BuildCodeParams>> = ({
  environment,
  notification,
  user
}) => {
  const mobileCodeSamples = CodeSamples.filter(
    (sample) => sample.codeType === CodeType.MOBILE
  );

  return (
    <>
      <CodeSampleTabs
        environment={environment}
        notification={notification}
        user={user}
        codeSamples={mobileCodeSamples}
        mergeTags={{}}
      />
      <Paragraph>
        For more information setting up mobile push notifications please see our{' '}
        <a
          href="https://docs.notificationapi.com/guides/mobile-push"
          target="_blank"
          rel="noreferrer"
        >
          guide for mobile push.
        </a>
      </Paragraph>
    </>
  );
};

export default MobileCodeSampleTabs;
